<template>
  <v-container fluid class="billing">
    <v-row v-if="loading" no-gutters justify="center" align="center" style="height: 600px;">
			<v-progress-circular
				:size="50"
				color="primary"
				indeterminate
			></v-progress-circular>
		</v-row>
    <template v-else>
      <v-form ref="pricingForm">
        <v-row no-gutters>
          <v-col cols="12">
            <v-checkbox
              v-model="active"
              color="primary"
              dense
              label="Ativo"
              class="mt-0 mb-3"
              hide-details
              style="max-width: 100px"
              @change="changeStatus"
            >
            </v-checkbox>
          </v-col>
          <v-col v-if="active" class="px-2">
            <v-card>
              <v-card-title v-translate>
                Tests
              </v-card-title>
              <v-card-text>
                <v-list>
                  <v-subheader>
                    <translate>Default</translate> <v-spacer></v-spacer> <translate>Price</translate>(€)
                  </v-subheader>
                  <p v-if="defaultTests.length == 0" class="font-weight-thin ml-5" v-translate>No default tests.</p>
                  <v-list-item v-for="test in defaultTests" :key="test.id" dense>
                    <v-list-item-content>
                      <v-list-item-title class="font-weigh-bold">
                        {{getName(test)}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-text-field
                        v-model="test.price"
                        outlined
                        hide-details
                        dense
                        style="max-width: 60px"
                        :rules="[isNumberNotRequired]"
                      ></v-text-field>
                    </v-list-item-action>
                  </v-list-item>
                  <v-subheader>
                    <translate>Custom</translate> <v-spacer></v-spacer> <translate>Price</translate>(€)
                  </v-subheader>
                  <p v-if="customTests.length == 0" class="font-weight-thin ml-5" v-translate>No custom tests.</p>
                  <v-list-item v-for="test in customTests" :key="test.id" dense>
                    <v-list-item-content>
                      <v-list-item-title class="font-weigh-bold">
                        {{test.name}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-text-field
                        v-model="test.price"
                        outlined
                        hide-details
                        dense
                        style="max-width: 60px"
                        :rules="[isNumberNotRequired]"
                      ></v-text-field>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="active" class="px-2">
            <v-card>
              <v-card-title v-translate>
                Treatments
              </v-card-title>
              <v-card-text>
                <v-list>
                  <v-subheader>
                    <translate>Default</translate> <v-spacer></v-spacer> <translate>Price</translate>(€)
                  </v-subheader>
                  <p v-if="defaultTreatments.length == 0" class="font-weight-thin ml-5" v-translate>No default tests.</p>
                  <v-list-item v-for="treatment in defaultTreatments" :key="treatment.id" dense>
                    <v-list-item-content>
                      <v-list-item-title class="font-weigh-bold">
                        {{getName(treatment)}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-text-field
                        v-model="treatment.price"
                        outlined
                        hide-details
                        dense
                        style="max-width: 60px"
                        :rules="[isNumberNotRequired]"
                      ></v-text-field>
                    </v-list-item-action>
                  </v-list-item>
                  <v-subheader>
                    <translate>Custom</translate> <v-spacer></v-spacer> <translate>Price</translate>(€)
                  </v-subheader>
                  <p v-if="customTreatments.length == 0" class="font-weight-thin ml-5" v-translate>No custom tests.</p>
                  <v-list-item v-for="treatment in customTreatments" :key="treatment.id" dense>
                    <v-list-item-content>
                      <v-list-item-title class="font-weigh-bold">
                        {{treatment.name}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-text-field
                        v-model="treatment.price"
                        outlined
                        hide-details
                        dense
                        style="max-width: 60px"
                        :rules="[isNumberNotRequired]"
                      ></v-text-field>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <template v-if="active">
      <v-row no-gutters class="pa-3 mt-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="savePricing" :loading="loadingSavePricing">
          <translate>Save</translate>
        </v-btn>
      </v-row>
      <v-row no-gutters class="my-3">
        <span class="text-subtitle-1 font-weight-regular primary--text ml-1">
          <translate>Appointment Types</translate>
        </span>
      </v-row>
      <v-divider class="mb-3"></v-divider>
      <v-row no-gutters class="mb-4 ml-3">
        <v-btn fab color="primary" small @click="clickNewAppointmentType">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
      <v-row no-gutters class="ma-2">
        <v-col>
          <p v-if="appointmentTypes.length == 0" class="font-weight-thin ml-5" v-translate>No appointment types.</p>
          <v-list v-else>
            <v-list-item style="border: 1px solid #e0e0e0; border-radius: 5px" v-for="appType in appointmentTypes" :key="appType.id" dense>
              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{appType.name}}</strong>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{appType.price}} €
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-row no-gutters>
                  <v-btn icon @click="clickEditAppointmentType(appType)">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>
                  <v-btn icon @click="appTypeToDelete = appType; showDeleteAppointmentType = true">
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <DeleteConfirmationDialog v-model="showDeleteAppointmentType" item="appointment_type" @delete="deleteAppointmentType" />
        </v-col>
      </v-row>
      <v-dialog v-model="showForm" max-width="80%" scrollable>
        <v-card>
          <v-card-title class="title primary--text mb-2 secondary">
            <translate>Appointment Type</translate>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-row no-gutters class="mt-2">
                <v-col cols="5">
                  <v-text-field
                    v-model="appointmentType.name"
                    :label="$gettext('Name')"
                    filled
                    hide-details
                    class="pa-2"
                    :rules="[required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="appointmentType.price"
                    :label="$gettext('Base Price')"
                    filled
                    hide-details
                    class="pa-2"
                    :rules="[required,isNumber]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="pa-3">
                  <v-card>
                    <v-card-title>
                      Inclui
                    </v-card-title>
                    <v-card-text>
                      <v-list>
                        <v-subheader>
                          <translate>Treatments</translate>
                        </v-subheader>
                        <p v-if="includedTreatments.length == 0" class="font-weight-thin ml-5" v-translate>No treatments.</p>
                        <v-list-item v-for="treatment in includedTreatments" :key="treatment.name" dense>
                          <v-list-item-content>
                            <v-list-item-title class="font-weigh-bold">
                              {{getName(treatment)}}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn small icon @click="treatment.excluded = true">
                              <v-icon small color="primary">mdi-arrow-right-thick</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-subheader>
                          <translate>Tests</translate>
                        </v-subheader>
                        <p v-if="includedTests.length == 0" class="font-weight-thin ml-5" v-translate>No tests.</p>
                        <v-list-item v-for="test in includedTests" :key="test.name" dense>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{getName(test)}}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn small icon @click="test.excluded = true">
                              <v-icon small color="primary">mdi-arrow-right-thick</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col class="pa-3">
                  <v-card>
                    <v-card-title>
                      Exclui
                    </v-card-title>
                    <v-card-text>
                      <v-list>
                        <v-subheader>
                          <translate>Treatments</translate> <v-spacer></v-spacer> <span v-if="excludedTreatments.length > 0"><translate>Price</translate>(€)</span>
                        </v-subheader>
                        <p v-if="excludedTreatments.length == 0" class="font-weight-thin ml-5" v-translate>No treatments.</p>
                        <v-list-item v-for="treatment in excludedTreatments" :key="treatment.name" dense>
                          <v-list-item-action>
                            <v-btn small icon @click="treatment.excluded = false">
                              <v-icon small color="primary">mdi-arrow-left-thick</v-icon>
                            </v-btn>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{getName(treatment)}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span v-if="treatment.price">{{treatment.price}} €</span>
                              <span v-else>- €</span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-row no-gutters align="center">
                              <span :class="getPercentage(treatment) > 0 ? 'green--text' : 'red--text'" class="mr-3 font-weight-bold" v-if="getPercentage(treatment)">{{getPercentage(treatment)}} %</span>
                              <v-text-field
                                v-model="treatment.new_price"
                                outlined
                                hide-details
                                dense
                                style="max-width: 60px"
                                :rules="[required, isNumber]"
                              ></v-text-field>
                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                        <v-subheader>
                          <translate>Tests</translate> <v-spacer></v-spacer> <translate v-if="excludedTests.length > 0">Price</translate>
                        </v-subheader>
                        <p v-if="excludedTests.length == 0" class="font-weight-thin ml-5" v-translate>No tests.</p>
                        <v-list-item v-for="test in excludedTests" :key="test.name" dense>
                          <v-list-item-action>
                            <v-btn small icon @click="test.excluded = false">
                              <v-icon small color="primary">mdi-arrow-left-thick</v-icon>
                            </v-btn>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{getName(test)}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{test.price}} €
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-row no-gutters align="center">
                              <span :class="getPercentage(test) > 0 ? 'green--text' : 'red--text'" class="mr-3 font-weight-bold" v-if="getPercentage(test)">{{getPercentage(test)}} %</span>
                              <v-text-field
                                v-model="test.new_price"
                                outlined
                                hide-details
                                dense
                                style="max-width: 60px"
                                :rules="[required, isNumber]"
                              ></v-text-field>
                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider class="my-3"></v-divider>
                        <v-row no-gutters>
                          <v-spacer></v-spacer><span class="font-weight-bold mr-2 primary--text">Max. Total:</span> <span class="font-weight-light">{{maxTotal}}€</span>
                        </v-row>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="showForm = false">
              <translate>Cancel</translate>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="editMode" color="primary" text @click="editAppointmentType" key="save" :loading="savingAppointmentType">
              <translate>Save</translate>
            </v-btn>
            <v-btn v-else color="primary" text @click="createAppointmentType" key="create" :loading="savingAppointmentType">
              <translate>Create</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </template>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "Billing",
  components: {
    DeleteConfirmationDialog
  },
  data: () => ({
    loading: true,
    loadingSavePricing: false,
    savingAppointmentType: false,
    appointmentType: {
      name: "",
      price: null
    },
    editMode: false,
    showForm: false,
    active: null,
    tests: [],
    treatments: [],
    appointmentTypes: [],
    showDeleteAppointmentType: false,
    appTypeToDelete: null,
    isNumberNotRequired: v => {
      if(!v) return true;
      if(!isNaN(v) && !isNaN(parseFloat(v))) return true;
      return "";
    }
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		},
		isNumber() {
			return value => (!isNaN(value) && !isNaN(parseFloat(value))) || this.$gettext("Invalid.");
    },
    defaultTests() {
      return this.tests.filter(t => t.code);
    },
    customTests() {
      return this.tests.filter(t => !t.code);
    },
    defaultTreatments() {
      return this.treatments.filter(t => t.code);
    },
    customTreatments() {
      return this.treatments.filter(t => !t.code);
    },
    includedTreatments() {
      return this.treatments.filter(t => !t.excluded);
    },
    excludedTreatments() {
      return this.treatments.filter(t => t.excluded);
    },
    includedTests() {
      return this.tests.filter(t => !t.excluded);
    },
    excludedTests() {
      return this.tests.filter(t => t.excluded);
    },
    maxTotal() {
      let total = 0;
      if(this.appointmentType.price) {
        total += parseFloat(this.appointmentType.price);
      }

      for(let i = 0; i < this.excludedTreatments.length; i++) {
        if(this.excludedTreatments[i].new_price) total += parseFloat(this.excludedTreatments[i].new_price);
      }
      for(let i = 0; i < this.excludedTests.length; i++) {
        if(this.excludedTests[i].new_price) total += parseFloat(this.excludedTests[i].new_price);
      }

      return total;
    }
  },
  methods: {
    getName(t) {
			if(t.code) {
				let code = t.code;
				if(code == 'general') return 'Sinais Vitais e Dados Antropométricos';
				if(code == 'ryodoraku') return 'Ryodoraku';
				if(code == 'tongue') return this.$gettext('Tongue');
				if(code == 'pulse') return this.$gettext('Pulse');
				if(code == 'abdominal-palpation') return this.$gettext('Abdominal Palpation');
				if(code == 'body-structure') return this.$gettext('Body Structure');
				if(code == 'osteo') return this.$gettext('Osteopathy');
				if(code == 'supp') return this.$gettext('Supplements');
				if(code == 'acu') return this.$gettext('Acupuncture');
				if(code == 'acu-auri') return this.$gettext('Auricular Acupuncture');
				if(code == 'cmm') return this.$gettext('Chinese Materia Medica');
				if(code == 'qg') return 'Qi Gong';
				if(code == 'tn') return 'Tui Na';
				if(code == 'nut') return this.$gettext('Nutrition');
			} else {
				return t.name;
			}
    },
    hasModule(code) {
      if(code == 'general' || code == 'nut') return this.$store.getters.hasAnyModule;
      if(code == 'ryodoraku' || 
         code == 'tongue' || 
         code == 'pulse' || 
         code == 'abdominal-palpation' || 
         code == 'body-structure' || 
         code == 'acu' || 
         code == 'acu-auri' || 
         code == 'cmm' || 
         code == 'qg' || 
         code == 'tn') return this.$store.getters.hasModule('mtc');
      if(code == 'supp') return this.$store.getters.hasModule('fito');
      if(code == 'osteo') return this.$store.getters.hasModule('osteo');
    },
    getPercentage(t) {
      if(!t.price || !t.new_price) return null;
      if(t.price != t.new_price) return Math.round(((((t.new_price * 100) / t.price) - 100) + Number.EPSILON) * 100) / 100
      else return null;
    },
    savePricing() {
      if(this.$refs.pricingForm.validate()) {
        this.loadingSavePricing = true;
        let data = {
          default_tests: this.defaultTests,
          custom_tests: this.customTests,
          default_treatments: this.defaultTreatments,
          custom_treatments: this.customTreatments
        }
        axios
          .post("/pricing", data)
          .then(response => {
            console.log(response.data);
            this.loadingSavePricing = false;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    createAppointmentType() {
      if(this.$refs.form.validate()) {
        this.savingAppointmentType = true;
        let data = {
          name: this.appointmentType.name,
          price: this.appointmentType.price,
          treatments: this.excludedTreatments,
          tests: this.excludedTests
        }
        axios
          .post("/appointment-type/new", data, {params: {pricing: true}})
          .then(response => {
            console.log(response.data);
            this.appointmentTypes.push(response.data.appointment_type);
            this.showForm = false;
            this.savingAppointmentType = false;
          })
          .catch(error => {
            console.log(error);
            this.savingAppointmentType = false;
          });
      }
    },
    deleteAppointmentType() {
      axios
        .post("/appointment-type/" + this.appTypeToDelete.id + "/delete")
          .then(response => {
            console.log(response.data);
            this.appointmentTypes.splice(this.appointmentTypes.indexOf(this.appTypeToDelete), 1);
            this.showDeleteAppointmentType = false;
            this.appTypeToDelete = null;
          })
          .catch(error => {
            console.log(error);
            this.showDeleteAppointmentType = false;
          });
    },
    editAppointmentType() {
      if(this.$refs.form.validate()) {
        this.savingAppointmentType = true;
        let id = this.appointmentType.id;
        let data = {
          name: this.appointmentType.name,
          price: this.appointmentType.price,
          treatments: this.excludedTreatments,
          tests: this.excludedTests
        }
        axios
          .post("/appointment-type/" + id + "/edit", data, {params: {pricing: true}})
          .then(response => {
            console.log(response.data);
            for(let i = 0; i < this.appointmentTypes.length; i++) {
              if(this.appointmentTypes[i].id == id) this.appointmentTypes[i] = response.data.appointment_type;
            }
            this.showForm = false;
            this.savingAppointmentType = false;
          })
          .catch(error => {
            console.log(error);
            this.savingAppointmentType = false;
          });
      }
    },
    clickNewAppointmentType() {
      this.reset();
      this.editMode = false;
      this.showForm = true;
    },
    clickEditAppointmentType(appType) {
      this.reset();
      this.appointmentType.name = appType.name;
      this.appointmentType.price = appType.price;
      this.appointmentType.id = appType.id;
      appType.tests.forEach(t => {
        this.tests.forEach(tt => {
          if(tt.id == t.id) {
            tt.excluded = true;
            tt.new_price = t.price;
          }
        })
      });
      appType.treatments.forEach(t => {
        this.treatments.forEach(tt => {
          if(tt.id == t.id) {
            tt.excluded = true;
            tt.new_price = t.price;
          }
        })
      });
      this.editMode = true;
      this.showForm = true;
    },
    reset() {
      this.appointmentType.name = "";
      this.appointmentType.price = null;
      this.tests.forEach(t => {t.excluded = false; t.new_price = null;});
      this.treatments.forEach(t => {t.excluded = false; t.new_price = null;});
    },
    changeStatus() {
      console.log(this.active);
      let data = {
        active: this.active
      }
      axios
        .post("/pricing/status", data)
        .then(response => {
            console.log(response.data);
            this.$store.dispatch("EDIT_PRICING", data.active);
          })
          .catch(error => {
            console.log(error);
          });
    },
    init() {
      this.tests = [];
      this.treatments = [];
      this.appointmentTypes = [];
      axios
      .get("/pricing")
      .then(response => {
        console.log(response.data);
        response.data.tests.forEach(t => {
          if(!t.code || this.hasModule(t.code)) this.tests.push(t);
        });
        response.data.treatments.forEach(t => {
          if(!t.code || this.hasModule(t.code)) this.treatments.push(t);
        });
        this.active = response.data.active;
        this.appointmentTypes = response.data.appointment_types;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped>
>>>.v-list-item__action .v-input__slot {
  padding: 8px !important
}
</style>